/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Action} from "../models/action";
import {ActionService} from "../services/action.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";

@Injectable()
//@Input() KHT - using the @Input() tag breaks certain resolvers after Angular 12 update
export class ActionsResolver implements Resolve<Action[]> {

  constructor(
    private mActionService: ActionService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Action[]> {
    try {
      return await this.mActionService.getAllActions();
    } catch (error) {
      console.error("Problem resolving Actions... Error: " + error, error);
    }
  }

}
